import { css } from 'glamor';
import typography from '../../utils/typography';

const relative = css({
  position: 'relative',
});

const absolute = css({
  position: 'absolute',
  width: '100%',
  top: 0,
  left: 0,
  zIndex: 1,
});

const anchorTopLg = css({
  '@media(min-width: 48em)': {
    position: 'absolute',
    width: '50%',
    top: 0,
    left: '50%',
    transform: 'translate(-50%)',
    zIndex: 1,
  },
});

const header = css({
  position: 'relative',
  margin: `${typography.rhythm(2)} 0`,
  color: 'rgba(0, 0, 0, 0.8)',
  zIndex: 2,
  textAlign: 'center',
  textTransform: 'uppercase',
});

const noPointer = css({
  pointerEvents: 'none',
});

const linkStyles = css({
  color: 'rgba(0, 0, 0, 0.8)',
  backgroundImage: 'none',
  textShadow: 'none',
  '@media(max-width: 48em)': {
    color: 'white',
  },
});

const workTitleWrapper = css({
  position: 'absolute',
  padding: typography.rhythm(1),
  top: '50%',
  left: '50%',
  transform: 'translate(-50%)',
  border: '1px solid white',
});

const workTitle = css({
  margin: 0,
  color: 'white',
});

export {
  relative,
  absolute,
  anchorTopLg,
  header,
  noPointer,
  linkStyles,
  workTitleWrapper,
  workTitle,
};



// WEBPACK FOOTER //
// ./src/components/WorkNav/styles.js